import './Popover-3ba3b962.css';

var classes = {"Popover":"prc-Popover-Popover-v1ShS","PopoverContent":"prc-Popover-PopoverContent-nMzFS"};

export { classes as default };
